// extracted by mini-css-extract-plugin
export default {"video":"InstallDeviceStep2_video__+Kv3U","ontop":"InstallDeviceStep2_ontop__19g7F"};